import React from "react";
import { motion } from "framer-motion";
import { useI18n } from "@/i18n/LanguageContext";

export default function Marquee() {
  const { t } = useI18n();
  const items = t.marquee;
  return (
    <section
      className="relative z-10 overflow-hidden border-y border-white/10 bg-[#050505] py-14"
      data-testid="marquee-section"
    >
      <motion.div
        className="flex whitespace-nowrap"
        animate={{ x: ["0%", "-50%"] }}
        transition={{ duration: 38, repeat: Infinity, ease: "linear" }}
      >
        {[0, 1].map((dup) => (
          <div key={dup} className="flex shrink-0 items-center">
            {items.map((item, i) => (
              <span key={i} className="flex items-center">
                <span className="mx-8 font-head text-6xl font-light tracking-tight text-stroke sm:text-8xl">
                  {item}
                </span>
                <span className="text-3xl text-[#a855f7]">✦</span>
              </span>
            ))}
          </div>
        ))}
      </motion.div>
    </section>
  );
}
